// extracted by mini-css-extract-plugin
export default {"title":"NoClasses_title__l8wzf","wrapper":"NoClasses_wrapper__UTWOA"};